import { Flex, type FlexProps } from '@chakra-ui/react';

export type UiFlexProps = FlexProps;

export const UiFlex = Flex;
